export default {
    "slug": "pirates",
    "title": "Mutiny!",
    "firstChapterKey": "ship",
    "chapters": {
        "ship": require("./ship").default,
	},
    "configuration": {
        "darkness": false,
        "squigglevision": false,
    },
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0,
        },
        "party": {
            "units": {
                "captain": {
                    "key": "captain",
                    "jobKey": "hammer",
                    "affiliation": "good",

                    "isRecruited": true,
                    "canBetray": true,

                    "maxhealth": 35,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                    ],

                    "name": "Flint",
                    "subtitle": "The Captain",
                    "bodyKey": "good",
                },
                "firstmate": {
                    "key": "firstmate",
                    "jobKey": "sword",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 30,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                    ],

                    "name": "Abraham",
                    "subtitle": "The First Mate",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "sharpshooter": {
                    "key": "sharpshooter",
                    "jobKey": "gun",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 30,
                    "power": 15,
                    "skills": [
                        "inflict-damage",
                        "smite",
                    ],

                    "name": "Ben",
                    "subtitle": "The Sharpshooter",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "quartermaster": {
                    "key": "quartermaster",
                    "jobKey": "hammer",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 30,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "push",
                    ],

                    "name": "John",
                    "subtitle": "The Quartermaster",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "mercenary": {
                    "key": "mercenary",
                    "jobKey": "dagger",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 25,
                    "power": 15,
                    "skills": [
                        "inflict-damage",
                        "pull",
                    ],

                    "name": "Alex",
                    "subtitle": "The Mercenary",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "cabinboy": {
                    "key": "cabinboy",
                    "jobKey": "spear",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                    ],

                    "name": "Jim",
                    "subtitle": "The Cabin Boy",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "missionary": {
                    "key": "missionary",
                    "jobKey": "priest",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "restore-health",
                    ],

                    "name": "Anders",
                    "subtitle": "The Missionary",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
                "bard": {
                    "key": "bard",
                    "jobKey": "bard",
                    "affiliation": "good",

                    "canBetray": true,

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "dance",
                    ],

                    "name": "Billy",
                    "subtitle": "The Bard",
                    "faceKey": "human",
                    "bodyKey": "good",
                },
            }
        },
    }
}
